package com.merkost.handpass.admin.contract

import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class CommandPaletteState(
    val isOpen: Boolean = false,
    val query: String = "",
    val results: AsyncSection<List<CommandResult>> = AsyncSection.Loaded(emptyList()),
    val selectedIndex: Int = 0,
) : MVIState

data class CommandResult(
    val type: CommandResultType,
    val id: String,
    val title: String,
    val subtitle: String?,
    val path: String,
)

enum class CommandResultType { User, Listing, Navigation }

sealed interface CommandPaletteIntent : MVIIntent {
    data object Close : CommandPaletteIntent
    data object Toggle : CommandPaletteIntent
    data class SetQuery(val value: String) : CommandPaletteIntent
    data class TapResult(val result: CommandResult) : CommandPaletteIntent
    data class SetResults(val results: AsyncSection<List<CommandResult>>) : CommandPaletteIntent
    data class MoveSelection(val delta: Int) : CommandPaletteIntent
    data object ConfirmSelection : CommandPaletteIntent
}

sealed interface CommandPaletteAction : MVIAction {
    data class Navigate(val path: String) : CommandPaletteAction
}
